import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import * as styles from "./DepartmentsNavItem.styles";
import { useTracking } from "../DepartmentsNav/hooks/useTracking/useTracking";
import { MegaNav } from "../MegaNav/MegaNav";
export var DepartmentsNavItem = function DepartmentsNavItem(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'inherit' : _ref$color,
    department = _ref.department,
    index = _ref.index,
    openIndex = _ref.openIndex,
    setNavClosed = _ref.setNavClosed,
    setNavOpen = _ref.setNavOpen,
    setRef = _ref.setRef;
  var isThisDeptNavOpen = openIndex === index;
  var items = department.items,
    title = department.title,
    url = department.url;
  var hasChildren = items.length > 0;
  var tracking = useTracking();
  var handleBlur = function handleBlur(e) {
    var focusIsStillWithinThisDept = e.currentTarget.contains(e.relatedTarget);
    if (!focusIsStillWithinThisDept) {
      setNavClosed();
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Escape') {
      setNavClosed();
    }
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      if (isThisDeptNavOpen) {
        setNavClosed();
      } else {
        setNavOpen(index);
      }
    }
  };
  var handleClick = function handleClick(e) {
    e.preventDefault();
    if (isThisDeptNavOpen) {
      setNavClosed();
    } else {
      setNavOpen(index);
      tracking.onMegaNavOpen(department);
    }
  };
  return /*#__PURE__*/React.createElement(_StyledLi, {
    key: index,
    onBlur: handleBlur,
    style: {
      '--department-link-color': color || 'inherit',
      '--horizontal-padding': pxToRem(theme.spacing.lg)
    },
    $_css: styles.item
  }, /*#__PURE__*/React.createElement(_StyledA, {
    "data-active": isThisDeptNavOpen,
    href: url,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    ref: setRef,
    $_css2: styles.link
  }, title), hasChildren && isThisDeptNavOpen && /*#__PURE__*/React.createElement(MegaNav, {
    departmentTitle: department.title,
    departmentUrl: department.url,
    level2Items: items
  }));
};
var _StyledLi = _styled("li")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledA = /*#__PURE__*/_styled2("a").withConfig({
  displayName: "DepartmentsNavItem___StyledA",
  componentId: "sc-12t7z7q-0"
})(["", ""], function (p) {
  return p.$_css2;
});